import { render, staticRenderFns } from "./ProductTeaserAddToCart.vue?vue&type=template&id=4047e7c9"
import script from "./ProductTeaserAddToCart.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductTeaserAddToCart.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports